import React, { useEffect, useState } from "react";
import Filter from "./Filter/Filter";
import classNames from "classnames/bind";
import Table from "./Table/Table";
import axiosClient from "../../../services/axiosClient";
import { formatDB, formatDate } from "../../../utils";
import Nodata from "../../History/NoData/Nodata";
import styles from "./WaitConfirm.module.css";
import { Toast } from "../../../components";
import { WaitConfirmContext } from "../../../contexts";
const cx = classNames.bind(styles);
const WaitConfirm = () => {
  const [isRefresh, setIsRefresh] = useState(false);
  const [textSearch, setTextSearch] = useState();
  const [accounts, setAccounts] = useState([]);
  const [dayStart, setDayStart] = useState();
  const [dayEnd, setDayEnd] = useState();
  const [userData, setUserData] = useState({ userName: '', typeCode: '' });
  const codeCompany = sessionStorage.getItem("company_code")


  useEffect(() => {
    async function getListAccountWait() {
      try {
        const day =
          dayEnd && dayStart
            ? { day_start: formatDB(dayStart), day_end: formatDB(dayEnd) }
            : {};
        const res = await axiosClient(`/userManagement/get-list-user-unverify/?company_code=${codeCompany}`, {
          params: {
            name: textSearch,
            ...day,
          },
        });
        setAccounts(res);
      }
      catch (e) {
        if (e.response.status === 403) {
          Toast.open("Bạn không có quyền xem danh sách người dùng chờ xác nhận", "danger")
        }
      }
    }
    getListAccountWait();
  }, [isRefresh, textSearch, dayEnd, dayStart]);

  const onChangeDayStart = (data) => {
    setDayStart(data);
  };
  const onChangeDayEnd = (data) => {
    setDayEnd(data);
  };
  return (
    <>
      <WaitConfirmContext.Provider
        value={{codeCompany, userData, setIsRefresh, isRefresh}}
      >
        <div className={cx("header")}>
          <h1 className={cx("title")}>Danh sách chờ xác nhận</h1>
        </div>
        <div className={cx("content")}>
          <Filter
            setIsRefresh={setIsRefresh}
            isRefresh={isRefresh}
            setSearch={setTextSearch}
            onChangeDayEnd={onChangeDayEnd}
            onChangeDayStart={onChangeDayStart}
            dayEnd={dayEnd}
            dayStart={dayStart}
          />
          <Table
            pages={1}
            setIsRefresh={setIsRefresh}
            listUser={accounts ? accounts : []}
            isRefresh={isRefresh}
            onGetUser={(data) => setUserData(data)}
          />
        </div>
      </WaitConfirmContext.Provider>
    </>
  );
};

export default WaitConfirm;
